export const arrowDoubleRightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" viewBox="-0.75 -0.75 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m11.542.703 10.049 10.05a.7.7 0 0 1 0 .994l-10.049 10.05M.995.703l10.049 10.05a.7.7 0 0 1 0 .994L.995 21.797"/></svg>`,
    name: 'arrow-double-right'
};